/**
 * Computes the difference in days between two dates
 * The last day is always counted as 1, even if the difference is less than a day.
 */
export function calculateDaysDifference(dateFrom: Date, dateTo: Date): number {
    const diffMs = dateTo.getTime() - dateFrom.getTime();
    const daysLeft = Math.ceil(diffMs / (24 * 60 * 60 * 1000));

    return Math.max(daysLeft, 0);
}
